import { Stack } from '@mui/material'
import { getUnassignedOrganizationalUsers } from 'api/users'
import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import { OrganizationalUser } from 'types'
import { UserOrgRolesAccessCodes } from '../UserOrgRolesAccessCodes/UserOrgRolesAccessCodes'
import { UserOrgRolesHistory } from '../UserOrgRolesHistory/UserOrgRolesHistory'
import { UserOrgRolesUnassignedUsers } from '../UserOrgRolesUnassignedUsers/UserOrgRolesUnassignedUsers'

export function UserOrgRoles({ user }: { user: OrganizationalUser }) {
  const { organizationId } = user
  const [needUpdateHistory, setNeedUpdateHistory] = useState(false)

  const unassignedUsersQuery = useQuery(['unassignedOrUsers', organizationId], () => {
    return getUnassignedOrganizationalUsers({ organizationId })
  })

  const handleUnassignedUsersRefresh = useCallback(async () => {
    await unassignedUsersQuery.refetch()
    setNeedUpdateHistory(true)
  }, [unassignedUsersQuery])

  const handleResetNeedUpdateHistory = useCallback(() => {
    setNeedUpdateHistory(false)
  }, [])

  const unassignedUsersData = unassignedUsersQuery.data?.data || []

  return (
    <Stack gap={4}>
      <UserOrgRolesUnassignedUsers
        data={unassignedUsersData}
        isLoading={unassignedUsersQuery.isFetching}
        onRefresh={handleUnassignedUsersRefresh}
        organizationId={organizationId}
      />

      <UserOrgRolesAccessCodes
        organizationId={organizationId}
        unassignedUsers={unassignedUsersData}
        onUnassignedUsersRefresh={handleUnassignedUsersRefresh}
      />

      <UserOrgRolesHistory
        organizationId={organizationId}
        needUpdate={needUpdateHistory}
        resetNeedUpdate={handleResetNeedUpdateHistory}
      />
    </Stack>
  )
}
